// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"913cd596c986ad0190b3","655":"ef2195554ecc6d5e33ed"}[chunkId] + ".js";
};